import { atom } from 'recoil';
import { ISetor } from '../../../commons/types/config';

export const setorAtom = atom<ISetor[]>({
  key: 'setor',
  default: [] as ISetor[],
});
